import { Store, MutationPayload } from 'vuex';

import { TypedObject } from '@/definitions';
import { deepMerge } from '@/utilities';
import { RootState } from '@/store/store.definitions';

type StoredValue = { value: any };

/**
 * PERSISTED STATE PLUGIN
 */

/**
 * persistedStatePlugin persists the state to LocalForage with every update to the store
 * @param store The root store of the application
 */
export const persistedStatePlugin = (store: Store<RootState>) => {
  store.subscribe((_mutations: MutationPayload, state: TypedObject) => {
    Object.keys(state).forEach(key => {
      const value: StoredValue = { value: state[key] };
      localStorage.setItem(key, JSON.stringify(value));
    });
  });
};

/**
 * loadPersistedstate merges the stored values with the initial RootState
 * @param rootState The root store of the application
 */
export const loadPersistedState = (rootState: RootState): RootState => {
  const storedState: TypedObject = {};
  Object.keys(rootState).forEach((key: string) => {
    const storedValue: string | null = localStorage.getItem(key);
    if (storedValue) {
      const item: StoredValue = JSON.parse(storedValue);
      storedState[key] = item.value;
    }
  });

  const mergedStates: RootState = deepMerge(storedState, rootState) as RootState;
  return mergedStates;
};